/* eslint-disable react/display-name */
/* eslint-disable react/no-multi-comp */
import React, { useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import MaterialTable from 'material-table';

import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Link,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';

import {
  SaveAlt as SaveAltIcon,
} from '@material-ui/icons';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import {
  ButtonWithLoading,
} from '../../../../components';

const OwnerTransactions = ({
  data,
  isSaving,
  onCreate,
  onDelete,
  onUpdate,
}) => {

  const [ newData, setNewData ] = useState({
    date: new Date(),
    type: 'deposit',
    description: '',
    amount: 0,
    invoiceURL: '',
  });

  const handleFieldChange = (name, value) => {
    setNewData({
      ...newData,
      [name]: value
    });
  }

  const handleClick = () => onCreate(newData);

  const columns = [
    { title: 'Date', field: 'date', type: 'date' },
    {
      title: 'Type',
      field: 'type',
      type: 'string',
      // lookup: { deposit: 'Deposit', withdraw: 'Withdraw', transfer: 'Transfer' },
      editComponent: (props) => (
        <FormControl fullWidth>
          <Select
            inputProps={{
              name: 'type',
              id: 'type'
            }}
            onChange={e => props.onChange(e.target.value)}
            value={props.value}
          >
            <MenuItem value={'deposit'}>Deposit</MenuItem>
            <MenuItem value={'withdraw'}>Withdraw</MenuItem>
            <MenuItem value={'transfer'}>Transfer</MenuItem>
          </Select>
        </FormControl>
      )
    },
    { title: 'Description', field: 'description', type: 'string' },
    {
      title: 'Amount',
      field: 'amount',
      type: 'currency',
      align: 'left',
    },
    {
      title: 'Invoice',
      field: 'invoiceURL',
      cellStyle: {paddingTop: 0, paddingBottom: 0,},
      render: ({ invoiceURL }) => (
        <>
          {invoiceURL ?
            <IconButton
              component={Link}
              href={invoiceURL}
              rel="noopener"
              target="_blank"
            >
              <SaveAltIcon />
            </IconButton> :
            null
          }
        </>
      )
    },
    {
      title: 'Share',
      field: 'share',
      editable: 'never',
      cellStyle: { backgroundColor: '#FAFAFA', },
      render: ({ share }) => `${share}%`,
    },
    {
      title: 'Deposit Balance',
      field: 'depositBalance',
      type: 'currency',
      editable: 'never',
      cellStyle: { backgroundColor: '#FAFAFA', },
      align: 'left',
    },
    {
      title: 'Income Balance',
      field: 'incomeBalance',
      type: 'currency',
      editable: 'never',
      cellStyle: { backgroundColor: '#FAFAFA', },
      align: 'left',
    },
    {
      title: 'Total Prize Money',
      field: 'totalPrizeMoneyBalance',
      type: 'currency',
      editable: 'never',
      cellStyle: { backgroundColor: '#FAFAFA', },
      align: 'left',
    },
  ];

  return (
    <Card>
      <CardHeader title="Syndication Transactions" />
      <Divider />
      <CardContent style={{ padding: 0, paddingBottom: 0 }}>

        {/* Add data panel */}
        <div style={{ padding: 16 }}>
          <Grid
            container
            spacing={4}
          >
            <Grid
              item
              xs={6}
              md={2}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disabled={isSaving}
                  disableToolbar
                  format="dd/MM/yyyy"
                  fullWidth
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  label="Date"
                  name="date"
                  onChange={(dateString) => handleFieldChange('date', dateString)}
                  value={newData.date}
                  variant="inline"
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid
              item
              xs={6}
              md={2}
            >
              <FormControl fullWidth>
                <InputLabel htmlFor="transactionType">Transaction Type</InputLabel>
                <Select
                  disabled={isSaving}
                  inputProps={{
                    name: 'type',
                    id: 'type'
                  }}
                  onChange={(event) => handleFieldChange('type', event.target.value)}
                  value={newData.type}
                >
                  <MenuItem value={'deposit'}>Deposit</MenuItem>
                  <MenuItem value={'withdraw'}>Withdraw</MenuItem>
                  <MenuItem value={'transfer'}>Transfer</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={6}
              md={3}
            >
              <TextField
                disabled={isSaving}
                fullWidth
                label="Description"
                name="description"
                onChange={(event) => handleFieldChange('description', event.target.value)}
                value={newData.description}
              />
            </Grid>
            <Grid
              item
              xs={6}
              md={2}
            >
              <TextField
                disabled={isSaving}
                fullWidth
                label="Amount"
                name="amount"
                onChange={(event) => handleFieldChange('amount', event.target.value)}
                type="number"
                value={newData.amount}
              />
            </Grid>
            <Grid
              item
              xs={6}
              md={3}
            >
              <TextField
                disabled={isSaving}
                fullWidth
                label="Invoice"
                name="invoiceURL"
                onChange={(event) => handleFieldChange('invoiceURL', event.target.value)}
                value={newData.invoiceURL}
              />
            </Grid>
            <Grid
              item
              xs={6}
            >
              <ButtonWithLoading
                color="primary"
                defaultLabel="Add Data"
                disabled={isSaving}
                isLoading={isSaving}
                loadingLabel="Adding..."
                onClick={handleClick}
                variant="contained"
              />
            </Grid>
          </Grid>
        </div>

        <Divider />

        {/* Table */}
        <MaterialTable
          columns={columns}
          components={{
            Container: props => <div>{props.children}</div>,
          }}
          data={data}
          editable={{
            isEditable: (rowData) => rowData.isOwner,
            isDeletable: (rowData) => rowData.isOwner,
            onRowDelete: onDelete,
            onRowUpdate: onUpdate,
          }}
          options={{
            actionsColumnIndex: -1,
            search: false,
            paging: false,
            draggable: false,
            showTitle: false,
            toolbar: false,
          }}
        />
      </CardContent>
    </Card>
  );
}

export default OwnerTransactions;
